import React from 'react';
import { ListMusic, BadgeIndianRupee, QrCode, BarChart3, ArrowRight, Users } from 'lucide-react';
import { Panel, PageHeading } from '../ui';
import { AdminPage } from '../AdminSidebar';
import { PLAYLISTS, LICENCE_POLICIES, ACTIVITIES } from '../../../lib/familyData';
export function Dashboard({
  onNavigate
}: {
  onNavigate: (p: AdminPage) => void;
}) {
  const stats = [{
    label: 'Playlists',
    value: PLAYLISTS.length,
    icon: <ListMusic className="h-5 w-5" data-id="element-444" data-mp="2i2guakg6luca" />
  }, {
    label: 'Activities',
    value: ACTIVITIES.length,
    icon: <BarChart3 className="h-5 w-5" data-id="element-445" data-mp="2e1wx5gvlyqq5" />
  }, {
    label: 'Licence policies',
    value: LICENCE_POLICIES.length,
    icon: <BadgeIndianRupee className="h-5 w-5" data-id="element-446" data-mp="2rtbcndqb49sg" />
  }, {
    label: 'Active parents',
    value: '2,140',
    icon: <Users className="h-5 w-5" data-id="element-447" data-mp="2mv9x32s3aslq" />
  }];
  const shortcuts: {
    page: AdminPage;
    title: string;
    desc: string;
    icon: React.ReactNode;
  }[] = [{
    page: 'playlists',
    title: 'Playlist Builder',
    desc: 'Curate playlists from published activities',
    icon: <ListMusic className="h-5 w-5" data-id="element-448" data-mp="17ad48y345j2e" />
  }, {
    page: 'licences',
    title: 'Licence Policies',
    desc: 'Manage subscription products & pricing',
    icon: <BadgeIndianRupee className="h-5 w-5" data-id="element-449" data-mp="1c9zhh7ixyzb7" />
  }, {
    page: 'analytics',
    title: 'Analytics',
    desc: 'In-WebView events & purchase funnel',
    icon: <BarChart3 className="h-5 w-5" data-id="element-450" data-mp="1gd4jza30v0zu" />
  }, {
    page: 'qr',
    title: 'QR Management',
    desc: 'The single Family App QR code',
    icon: <QrCode className="h-5 w-5" data-id="element-451" data-mp="1q97hg2mxibgg" />
  }];
  return <div data-id="element-452" data-mp="1q8pekn5rgyzk">
      <PageHeading title="Dashboard" subtitle="Rangeet Family App admin panel — built by Rangeet with Claude Code." data-id="element-453" data-mp="1q6v648boezcd" />

      <div className="grid grid-cols-2 gap-4 xl:grid-cols-4" data-id="element-454" data-mp="1zy90k1ort8yn">
        {stats.map(s => <div key={s.label} className="rounded-lg border border-slate-200 bg-white p-4 shadow-sm" data-id="element-455" data-mp="240483nxaoikv">
            <div className="flex items-center gap-2 text-[#1e2a5a]" data-id="element-456" data-mp="290rxk55vkrcz">
              {s.icon}
              <span className="text-2xl font-bold" data-id="element-457" data-mp="2dzbnegnlanam">{s.value}</span>
            </div>
            <p className="mt-1 text-xs text-slate-500" data-id="element-458" data-mp="dvixj3iwubqf">{s.label}</p>
          </div>)}
      </div>

      <div className="mt-5 grid gap-5 lg:grid-cols-2" data-id="element-459" data-mp="8y8xyv1t4jov">
        <Panel title="Quick actions" data-id="element-460" data-mp="8vd2dddfm73l">
          <div className="grid grid-cols-1 gap-2 p-4 sm:grid-cols-2" data-id="element-461" data-mp="nmdlqdfpvlei">
            {shortcuts.map(s => <button key={s.page} onClick={() => onNavigate(s.page)} className="flex items-start gap-3 rounded-lg border border-slate-200 p-3 text-left transition hover:border-[#1e2a5a] hover:bg-[#1e2a5a]/5" data-id="element-462" data-mp="iuc7ilyznklu">
                <span className="text-[#1e2a5a]" data-id="element-463" data-mp="16lhq38wbcqzu">{s.icon}</span>
                <span className="min-w-0 flex-1" data-id="element-464" data-mp="16ivft1i1fxdx">
                  <span className="flex items-center justify-between font-semibold text-slate-800" data-id="element-465" data-mp="11mwob51exz9a">
                    {s.title}
                    <ArrowRight className="h-4 w-4 text-slate-400" data-id="element-466" data-mp="38cl2a2luqdmi" />
                  </span>
                  <span className="text-xs text-slate-500" data-id="element-467" data-mp="33esz2cfrb530">{s.desc}</span>
                </span>
              </button>)}
          </div>
        </Panel>

        <Panel title="Scope split (SoftBD brief)" data-id="element-468" data-mp="1nujy72jv5abq">
          <div className="grid grid-cols-1 gap-3 p-4 sm:grid-cols-2" data-id="element-469" data-mp="1nwd5mk2avyks">
            <div className="rounded-lg bg-[#1e2a5a]/5 p-3" data-id="element-470" data-mp="194mi79w37qxm">
              <p className="mb-1 text-xs font-bold uppercase tracking-wide text-[#1e2a5a]" data-id="element-471" data-mp="1e47hjlf661av">
                SoftBD builds (Flutter / backend)
              </p>
              <ul className="space-y-1 text-xs text-slate-600" data-id="element-472" data-mp="103em8yh1n26p">
                <li data-id="element-473" data-mp="154u3efg3oojt">• Parent user type & account creation</li>
                <li data-id="element-474" data-mp="q6joihslh5th">• QR routing + WebView container</li>
                <li data-id="element-475" data-mp="q834s8e93gv9">• JS payment bridge → Razorpay</li>
                <li data-id="element-476" data-mp="v538wdrji9jq">• Idempotent webhook, FCM, merge txn</li>
                <li data-id="element-477" data-mp="v7pggdefkp1y">• API endpoints (multi-language)</li>
              </ul>
            </div>
            <div className="rounded-lg bg-[#C08497]/10 p-3" data-id="element-478" data-mp="2klcdvz2vx0cz">
              <p className="mb-1 text-xs font-bold uppercase tracking-wide text-[#C08497]" data-id="element-479" data-mp="2pjw102t7si6x">
                Rangeet builds (this prototype)
              </p>
              <ul className="space-y-1 text-xs text-slate-600" data-id="element-480" data-mp="pf1wycc8340s">
                <li data-id="element-481" data-mp="lgaya0s3zebk">• Family App web app (WebView)</li>
                <li data-id="element-482" data-mp="gg6tv94h6a1p">• Home, playlists, purchase, saved</li>
                <li data-id="element-483" data-mp="git0n6jjkliv">• Admin: playlist builder, licences</li>
                <li data-id="element-484" data-mp="bgk4k1bdh3cj">• Analytics dashboards, content sync</li>
                <li data-id="element-485" data-mp="6iikpe64h000">• QR management</li>
              </ul>
            </div>
          </div>
        </Panel>
      </div>
    </div>;
}